// src/WordSearchBoard.js
import React, { useState, useEffect, useRef } from 'react';
import { generateWordSearch } from './wordSearchLogic';
import html2canvas from 'html2canvas';

// 1. ???? words ? difficulty ?? ??? Props ??? ??????? ?? ??? Generator
const WordSearchBoard = ({ onAddToBook, seed = null, words = null, difficulty = 'medium' }) => {
  
  // 2. ?????? ??????? ???? ???? ?? ??? (Theme) ?? ??????? ??????????
  const initialWords = words 
    ? (Array.isArray(words) ? words.join(', ') : words)
    : 'REACT, CODE, JAVA, HTML, CSS, NODE';

  const [grid, setGrid] = useState([]);
  const [inputWords, setInputWords] = useState(initialWords);
  const [wordsUsed, setWordsUsed] = useState([]);
  const [solution, setSolution] = useState([]);
  const [showSolution, setShowSolution] = useState(false);
  const printRef = useRef();

  const createGame = () => {
    // ??? ??? ????? seed (???? ????? ?? Generator)? ????? ???????? ???? ??? Theme
    const wordsToUse = seed && words ? initialWords : inputWords;
    const wordsList = wordsToUse.split(',').map(w => w.trim()).filter(w => w);
    
    // 3. ????? ???? ?????? ???????????? ??? ???? ???????
    const gridSize = difficulty === 'easy' ? 10 : (difficulty === 'medium' ? 12 : 15);

    const game = generateWordSearch(gridSize, wordsList, seed);
    
    setGrid(game.grid);
    setSolution(game.placedWords);
    setWordsUsed(wordsList);
    setShowSolution(false);
  };

  // 4. ????? ?????? ??? ????? ??????? ??? ??? seed
  useEffect(() => {
    if (words) setInputWords(initialWords);
    createGame();
  }, [seed, words, difficulty]);

  const handleGenerate = () => {
    if (!seed) createGame();
  };

  const handleAddToBook = () => {
    if (printRef.current) {
      const wasShowing = showSolution;
      setShowSolution(false);
      
      setTimeout(() => {
        html2canvas(printRef.current).then((canvas) => {
          onAddToBook('WordSearch', canvas.toDataURL(), { seed, words: inputWords, difficulty });
          if(wasShowing) setShowSolution(true); 
        });
      }, 100);
    }
  };

  const isCellInSolution = (r, c) => {
    if (!showSolution) return false;
    return solution.some(({ start, end }) => {
        const dr = end.r - start.r;
        const dc = end.c - start.c;
        const steps = Math.max(Math.abs(dr), Math.abs(dc));
        
        for(let i=0; i<=steps; i++) {
            const tr = start.r + Math.round((dr / steps) * i);
            const tc = start.c + Math.round((dc / steps) * i);
            if (tr === r && tc === c) return true;
        }
        return false;
    });
  };

  return (
    <div style={{ padding: '20px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <h2 style={{color: '#2d3436', fontFamily: 'sans-serif'}}>
        Word Search ?? 
        {seed && <span style={{fontSize:'0.6em', color:'gray', marginLeft:'10px'}}>ID: {seed}</span>}
      </h2>
      
      {!seed && (
        <div style={{ marginBottom: '20px', background: 'white', padding: '15px', borderRadius: '10px', boxShadow: '0 2px 5px rgba(0,0,0,0.1)', width:'100%', maxWidth:'600px', display:'flex', gap:'10px', flexWrap:'wrap', justifyContent:'center' }}>
          <input 
            type="text" 
            value={inputWords} 
            onChange={(e) => setInputWords(e.target.value)} 
            placeholder="Words separated by comma..."
            style={{flex:1, minWidth:'200px', padding:'10px', borderRadius:'5px', border:'1px solid #ccc'}}
          />
          <button onClick={handleGenerate} style={btnStyle('#6c5ce7')}>?? New</button>
          <button onClick={() => setShowSolution(!showSolution)} style={btnStyle(showSolution ? '#e17055' : '#00b894')}>
            {showSolution ? 'Hide' : 'Solution'}
          </button>
          <button onClick={handleAddToBook} style={btnStyle('#e67e22')}>?? Add</button>
        </div>
      )}

      <div ref={printRef} style={{ padding: '30px', background: 'white', display:'flex', flexDirection:'column', alignItems:'center', border: seed ? 'none' : '1px solid #eee' }}>
        
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: `repeat(${grid.length > 0 ? grid[0].length : 12}, 30px)`, 
          gap: '1px', 
          border: '2px solid #2d3436', 
          background: '#2d3436',
          marginBottom: '20px'
        }}>
          {grid.map((row, r) => row.map((char, c) => {
            const highlight = isCellInSolution(r, c);
            return (
              <div key={`${r}-${c}`} style={{
                width: '30px', height: '30px', 
                background: highlight ? '#ffeaa7' : 'white',
                color: highlight ? '#d63031' : '#2d3436',
                display: 'flex', justifyContent: 'center', alignItems: 'center',
                fontWeight: 'bold', fontSize:'16px',
                transition: '0.3s'
              }}>
                {char}
              </div>
            );
          }))}
        </div>

        {/* 5. ???????? ?????? ???? ??????? ??? ???? ???? ?? ?????? */}
        <div style={{ marginTop: '10px', width: '100%', maxWidth: '350px', textAlign: 'center' }}>
           <div style={{ fontSize: '15px', fontWeight: '900', marginBottom: '12px', color: '#2d3436', textTransform: 'uppercase', letterSpacing: '1px', borderBottom: '2px solid #dfe6e9', paddingBottom: '5px' }}>
              Words to Find
           </div>
           <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '8px' }}>
               {wordsUsed.map((w, i) => (
                   <span key={i} style={{ fontSize: '12px', fontWeight: 'bold', color: '#636e72', textTransform: 'uppercase', background: '#f1f2f6', padding: '5px 10px', borderRadius: '4px' }}>
                       {w}
                   </span>
               ))}
           </div>
        </div>

      </div>
    </div>
  );
};

const btnStyle = (bg) => ({ background: bg, color: 'white', border: 'none', padding: '10px 20px', borderRadius: '5px', cursor: 'pointer', fontWeight: 'bold' });
export default WordSearchBoard;